export const ADD_LANGUAGE = "ADD_LANGUAGE"
export const EDIT_LANGUAGE= "EDIT_LANGUAGE"
export const LIST_LANGUAGE = "LIST_LANGUAGE"
export const VIEW_LANGUAGE = "VIEW_LANGUAGE"
export const DELETE_LANGUAGE = "DELETE_LANGUAGE"

export const LANGUAGE_SUCCESS = "LANGUAGE_SUCCESS"
export const LANGUAGE_ERROR = "LANGUAGE_ERROR"
